import { RootState } from '../../store';

export const getIsLoggedSelector = (state: RootState) => state?.authReducer?.isLogged;
